import { Machine, assign } from 'xstate';

export default Machine({
  id: 'verification',
  initial: 'INSTRUCTIONS',
  context: {
    retriesLeft: 2,
  },
  states: {
    INSTRUCTIONS: {
      on: {
        NEXT: 'TXT_RECORD',
      },
    },
    TXT_RECORD: {
      on: {
        VERIFY_DNS: 'VERIFYING_DNS',
        BACK: 'INSTRUCTIONS',
      },
    },
    VERIFYING_DNS: {
      invoke: {
        src: 'verifyDNS',
      },
      on: {
        VERIFIED: 'RECOMMENDATIONS',
        ERROR: [
          {
            target: 'ERROR_FINAL',
            cond: cxt => cxt.retriesLeft === 0,
          },
          'ERROR',
        ],
        ERROR_FINAL_NOT_OWNER: {
          target: 'ERROR_FINAL_NOT_OWNER',
        },
      },
    },
    ERROR: {
      on: {
        BACK: 'TXT_RECORD',
      },
      exit: assign({ retriesLeft: ctx => ctx.retriesLeft - 1 }),
    },
    RECOMMENDATIONS: {
      type: 'final',
    },
    ERROR_FINAL: {
      type: 'final',
    },
    ERROR_FINAL_NOT_OWNER: {
      type: 'final',
    },
  },
});
